import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../components/HomePage.vue'

import MainForm from '../components/shared/MainForm'
import OffersSection from '../components/OffersSection'
import FinishSection from '../components/FinishSection'
import FormsSection from '../components/FormsSection'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: HomePage,
            children: [
                { path: '/', redirect: '/form/round-trip' },
                {
                    path: '/form',
                    component: FormsSection,
                    children: [
                        { path: '/', redirect: '/form/round-trip' },
                        { path: ':type', component: MainForm },
                    ],
                },
                { path: '/offers', component: OffersSection, props: (route) => ({ formValue: route.query }) },
                { path: '/finish', component: FinishSection, props: (route) => ({ person: route.query }) },
            ],
        },
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView()
    },
})



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js